import React from 'react'
import { components } from 'react-select'
import { Col } from 'react-bootstrap'
import { SelectAsync } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'
import { ProjectStatus } from '../project-status/ProjectStatus'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'

const projectDocumentFragment = gql`
  fragment projectDocumentFragment on Project {
    _id
    code
    name
    status
    tasks {
      _id
      code
      name
      project {
        _id
      }
      workOrder {
        _id
      }
    }
  }
`

export const queries = buildGraphqlQuery('Project', projectDocumentFragment)

const Option = ({ data, ...rest }: any) => {
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <HorizontalStack gap={2}>
        <div className="flex-shrink-0 text-nowrap">
          <HorizontalStack gap={0}>
            <ProjectStatus status={data?.status} />
            <div className="fw-bold">{data?.code}</div>
          </HorizontalStack>
        </div>

        <Col className="text-truncate">
          <small>{data?.name}</small>
        </Col>
      </HorizontalStack>
    </components.Option>
  )
}

const dataLoadOptions = ({ filter }) => {
  return {
    query: queries.allNoMetaConfig.query,
    resultFieldName: 'allProject',
    filter: ({ input }) => {
      const result = {
        $and: [
          { $or: [{ code: { $regex: input, $options: 'i' } }, { name: { $regex: input, $options: 'i' } }] },
          filter,
        ],
      }
      return result
    },
  }
}

export const ProjectSelect = ({ filter, ...rest }) => {
  const selectDefaultProps = {
    ...rest,
    components: { Option },
    placeholder: 'Type project code or name',
    labelKey: 'code',
    noOptionsMessage: () => 'Cannot find any projects.',
  }

  return (
    <div className={'d-flex '}>
      <div style={{ width: '100%' }} className={'m-r-sm'}>
        <SelectAsync
          {...{
            ...selectDefaultProps,
            dataLoadOptions: dataLoadOptions({ filter }),
          }}
        />
      </div>
    </div>
  )
}
